import React from 'react';
import { useQuery } from 'react-admin';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import * as R from 'ramda';
import moment from 'moment-timezone';
import { sumAttendanceMinutes } from 'utils';

const ZoomTotalMinutesField = ({
  date,
  record,
  isAbsent,
  attendanceDataOverride,
  loadingOverride,
  errorOverride,
}) => {
  const { data, loading, error } = useQuery({
    type: 'getManyReference',
    resource: 'zoom_attendance',
    payload: {
      search: [
        {
          $match: {
            $and: [
              { student_id: record.id },
              { session_date: moment(date).format('YYYY-MM-DD') },
            ],
          },
        },
      ],
      pagination: {
        perPage: 1000,
      },
      sort: { field: 'join_time', order: 'ASC' },
    },
  });

  const effectiveLoading =
    typeof loadingOverride === 'boolean' ? loadingOverride : loading;
  const effectiveError =
    typeof errorOverride !== 'undefined' ? errorOverride : error;
  const effectiveData = attendanceDataOverride || data;

  if (effectiveLoading) {
    return (
      <Box display="flex" alignItems="center">
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (effectiveError && effectiveError.message !== 'No attendance data') {
    return (
      <Typography
        variant="body2"
        color="error"
        sx={{
          textAlign: 'center',
        }}
      >
        Error
      </Typography>
    );
  }

  if (isAbsent || !effectiveData || R.isEmpty(effectiveData)) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          textAlign: 'center',
        }}
      >
        0 min
      </Typography>
    );
  }

  // Calculate total minutes from all zoom attendance records (shared helper)
  const totalMinutes = sumAttendanceMinutes(effectiveData);

  return (
    <Box>
      <Typography
        variant="body2"
        color="textPrimary"
        sx={{
          textAlign: 'center',
          fontWeight: 'medium',
        }}
      >
        {totalMinutes} min
      </Typography>
    </Box>
  );
};

export default ZoomTotalMinutesField;
